import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toConfirmEmailData = (data: unknown): TConfirmEmailWorkflowData => {
    return {
        workflow: toWorkflowData(data),
        workflowType: 'confirm-email',
        email: get(data, 'email'),
        user: get(data, '_embedded.user'),
    }
}
